import { useStore } from 'effector-react'

import {
  $totalCountOfParticipants,
  getParticipants,
  participantsListMounted,
  $participants,
  banParticipantTriggered,
  unbanParticipantTriggered,
  updateParticipantFx,
} from './model'
import { ParticipantListRequest } from './types'

export const useParticipantsList = () => {
  const participants = useStore($participants)
  const loading = useStore(getParticipants.pending)
  const totalCountOfParticipants = useStore($totalCountOfParticipants)
  const updateLoading = useStore(updateParticipantFx.pending)

  const onChangeParticipantsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    filters,
  }: ParticipantListRequest) => {
    participantsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      filters,
    })
  }

  return {
    participants,
    totalCountOfParticipants,
    loading,
    onChangeParticipantsList,
    banParticipant: banParticipantTriggered,
    unbanParticipant: unbanParticipantTriggered,
    updateLoading,
  }
}
